import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    Avatar,
    Card,
    Col,
    Drawer,
    Dropdown,
    Menu,
    Modal,
    Row,
    Skeleton,
    Space,
    Spin,
    Tooltip,
} from 'antd'
import TodoStyles from '../../BackLog/backLogList.less'
import {
    FormOutlined,
    UsergroupAddOutlined,
    FieldTimeOutlined,
    UnorderedListOutlined,
    PaperClipOutlined,
    WechatOutlined,
    UserOutlined,
} from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import { getusersdroplist } from '../../../Services/Helpdesk/Backlog'
import {
    type todoForminterface,
    type todoSatteInterface,
    type TaskData,
    type setTasks,
    type Task,
} from '../../../Types/HelpDesk/Cretetask'
import {
    GetSatusList,
    GetTaskData,
    GetTaskList,
    Saveprojectstaus,
    Saveuserstaus,
} from '../../../Services/Helpdesk/CreteTask'
import CreateTaskForm from './CreateTaskForm'
import CreateFollowersModal from './CreateFoolwers'
import CreateHours from './CreateHours'
import CreateattachmentModal from './Attachment'

import {
    commonTableParams,
    setCommonTableParamsData,
} from '../../../Utils/CommontTable'
import { type TableParamsInterface } from '../../../Types/CommonType'
import { type ProjectManagmentStausListDataTypeInterface } from '../../../Types/ProjectMangement'
import { TaskdefaultData } from './toDoTasks'
import CreatesubtaskModal from './Tabs'
import ChatClient from './chatClient'
import { type DataCHAT } from '../../../Types/Client/ProspectClients/prospectClient'
import { formatdate } from '../../../Utils/dateFormat'
export const TaskItemDefaultData = {
    taskId: '',
    taskNo: 0,
    taskName: '',
    priorityName: '',
    priorityColourCode: '',
    taskTypeName: '',
    sortOrder: 0,
    businessTypeName: '',
    clientName: '',
    serviceName: '',
    description: '',
    assignedByName: '',
    assignedToName: '',
    fromDate: '',
    toDate: '',
    daysCount: 0,
    daysColourCode: '',
    status: '',
    statusColourCode: '',
    notifyToStatusChange: 0,
    subTaskViews: [],
    taskFollowerViews: [],
    subTaskStatus: 0,
    isNewChatExist: 0,
    projectTierInfo: '',
    projectStatusId: 0,
    projectStatusLbl: '',
    userStatusId: 0,
    userStatusLbl: '',
}

const CompletedTask = (
    props: todoForminterface & { activeStates: string }
): React.ReactElement => {
    const dispatch = useDispatch()
    const [modalTitleCreate, setModalTitleCreate] = useState('Add Dates')
    const [modalVisibleCreate, setModalVisibleCreate] = useState(false)
    const [modalVisibleCreateHours, setModalVisibleCreateHours] =
        useState(false)
    const [selectedTaskId, setSelectedTaskId] = useState<string>('')
    const [createEditModalStatus, setCreateEditModalStatus] = useState(false)
    const [, setSelectedStatusProjectId] = useState<string>('')
    const [modalVisibleCreateAttachment, setModalVisibleCreateAttachment] =
        useState(false)
    const [modalVisibleCreateFollowers, setModalVisibleCreateFollowers] =
        useState(false)
    const [attachmentTaskId, setAttachmentTaskId] = useState('')
    const [editData, setEditData] = useState<setTasks>(TaskdefaultData)
    const [tableParams] = useState<TableParamsInterface>(commonTableParams)
    const [isLoading, setLoading] = useState(false)
    const [idChange, setIDchange] = useState('')
    const [, setUerStatusfilter] = useState(3)
    const hasFetchedOnce2 = useRef(false)
    const [CompletedTaskList, setCompletedTask] = useState<TaskData[]>([])
    const [referenceId, setRefernceId] = useState(0)
    const [businessId, setBusinessId] = useState(0)
    const [modalVisibleCreateChat, setModalVisibleCreateChat] = useState(false)
    const [modalVisibleCreateSubTask, setModalVisibleCreateSubTask] =
        useState(false)
    const [getTask, setTask] = useState<Task>(TaskItemDefaultData)
    const [projectStatusLable, setProjectStatusLable] = useState('')
    const {
        ProjectManagmentStausList,
        setSelectedTaskIds,
        selectedProjectID,
        AssignBY,
        activeItDepartment,
        activeStates,
        taskDetailsList,
        activeTab,
        AssignTo,
        searchString,
        createTaskModalStatus,
        departmentId,
    } = props

    const [selectedUsers, setSelectedUsers] = useState<number[]>([])
    const hasFetchedOnce = useRef(false)
    const [drawerDetails, setDrawerDetaisl] = useState<DataCHAT | null>(null)
    const [restData, setResetData] = useState('false')
    const [restData2, setResetData2] = useState('false')

    // useEffect(() => {
    //     if (selectedProjectID === 0) {
    //         // setUerStatusfilter(1)

    //     }
    // }, [
    //     AssignTo,
    //     AssignBY,
    //     selectedProjectID,
    //     searchString,
    //     createTaskModalStatus,
    //     idChange,
    //     activeStates,
    //     departmentId,
    // ])
    const getTableDatas = useCallback(() => {
        let projectStatusName = 'Complete'

        if (activeTab === '2') {
            projectStatusName = 'Complete'
        }

        const todoProject = ProjectManagmentStausList.find(
            (project) => project.projectStatusName === projectStatusName
        )

        const id = todoProject?.projectStatusId

        if (id !== undefined && selectedProjectID !== undefined) {
            setUerStatusfilter(3)
            void GetTaskList(
                dispatch,
                id?.toString(),
                searchString?.toString(),
                1,
                10000,
                AssignBY,
                AssignTo,
                departmentId,
                selectedProjectID
            )
        } else {
            setUerStatusfilter(10)
            void GetTaskList(
                dispatch,
                '0',
                searchString?.toString(),
                1,
                10000,
                AssignBY ?? 0,
                AssignTo ?? 0,
                departmentId,
                selectedProjectID
            )
        }
    }, [
        ProjectManagmentStausList,
        selectedProjectID,
        idChange,
        activeStates,
        activeTab,
        AssignBY,
        AssignTo,
        searchString,
        createTaskModalStatus,
        departmentId,
    ])

    useEffect(() => {
        getTableDatas()
    }, [getTableDatas])

    useEffect(() => {
        const completedList = taskDetailsList.filter(
            (data) =>
                data.projectStatusLbl === 'Complete' &&
                data.userStatusLbl === 'Completed'
        )
        setCompletedTask(completedList)
    }, [taskDetailsList, activeTab])
    const handleModalOpenCreate = (taskId: string): void => {
        setModalVisibleCreate(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Edit Task Details')
    }

    const handleModalOpenCreateHours = (taskId: string): void => {
        setModalVisibleCreateHours(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Spent Hours')
    }

    const handleModalOpenCreateFollowers = (taskId: string): void => {
        setModalVisibleCreateFollowers(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Followers')
    }

    const handleModalOpenSubTasks = (task: Task): void => {
        setModalVisibleCreateSubTask(true)
        setAttachmentTaskId(task.taskId)
        setTask(task)
        setModalTitleCreate('Add SubTask')
    }

    const onAttachment = (taskId: string): void => {
        setModalVisibleCreateAttachment(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Add Task Attachment')
    }

    const onChat = (
        taskId: string,
        referenceId: number,
        businessId: number
    ): void => {
        setRefernceId(referenceId)
        setBusinessId(businessId)
        setModalVisibleCreateChat(true)
        setAttachmentTaskId(taskId)
        setModalTitleCreate('Staff Communication')
    }

    const handleModalClose = (): void => {
        setModalVisibleCreate(false)
        setModalVisibleCreateAttachment(false)
        setModalVisibleCreateHours(false)
        setModalVisibleCreateFollowers(false)
        setModalVisibleCreateSubTask(false)
        setModalVisibleCreateChat(false)
    }

    const changeCreateEditModalStatus = (): void => {
        setCreateEditModalStatus(!createEditModalStatus)
    }

    const onSaveTask = (callBack: CallableFunction): void => {
        setModalVisibleCreateFollowers(false)
        changeCreateEditModalStatus()
        callBack()
        getTableDatas()
    }

    useEffect(() => {
        if (!hasFetchedOnce2.current) {
            hasFetchedOnce2.current = true
            return
        }
        void getusersdroplist(dispatch)
    }, [])

    const getTableData = useCallback(() => {
        const { pageSize, pageNo, sortOrderList, searchCriteriaList } =
            setCommonTableParamsData(tableParams)
        if (selectedProjectID !== undefined && selectedProjectID !== null) {
            GetSatusList(dispatch, selectedProjectID?.toString(), {
                pageNo,
                pageSize,
                searchCriteriaList,
                sortOrderList,
            })
        }
    }, [selectedProjectID])

    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        getTableData()
    }, [getTableData])

    const handleAssignByMenuClick = (
        taskId: string,
        statusProjectId: string
    ): void => {
        setSelectedTaskId(taskId)
        setSelectedStatusProjectId(statusProjectId)
    }

    const todoProjectStatusId = (
        name: string | undefined
    ): string | undefined => {
        const todoProject = ProjectManagmentStausList.find(
            (project: ProjectManagmentStausListDataTypeInterface) =>
                project.projectStatusName === name
        )
        const todoProjectId = todoProject?.projectStatusId?.toString()

        return todoProjectId
    }

    const handleProgressChange = async (
        value: number,
        projectStatusName: string
    ): Promise<void> => {
        try {
            setLoading(true)
            const statusId = todoProjectStatusId(projectStatusName)
            let StatusIDS = 0

            if (statusId !== undefined) {
                StatusIDS = Number(statusId)
            } else {
                StatusIDS = 0
            }
            await Saveuserstaus(dispatch, selectedTaskId, value?.toString())
            await Saveprojectstaus(
                dispatch,
                selectedTaskId,
                Number(StatusIDS),
                projectStatusName
            )
            getTableDatas()
            setIDchange(selectedTaskId)
            setSelectedTaskIds(selectedTaskId)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const openEditModal = (id: string): void => {
        void openEditData(id)
    }
    const openEditData = async (id: string): Promise<void> => {
        // const data = taskDetailsList.find((data: TaskData) => {
        //     return data.taskId === id
        // })
        try {
            const data = await GetTaskData(dispatch, id)
            setEditData(data ?? TaskdefaultData)
        } catch (err) {}
    }

    return (
        <div>
            <Spin spinning={isLoading}>
                <Card className={TodoStyles.todoCard} title="">
                    {CompletedTaskList
                        // .filter(
                        //     (task) => task.userStatusId === uerStatusfilter
                        // )
                        .map((task: TaskData) => (
                            <Card
                                key={task.taskId}
                                className={TodoStyles.todoItem}
                            >
                                <div className={TodoStyles.tasknameStyles}>
                                    <div>
                                        <strong>{task.taskName}</strong> {'  '}
                                        {task.clientName !== '' && (
                                            <span> ({task.clientName})</span>
                                        )}
                                    </div>
                                    <div className={TodoStyles.taskAndColor}>
                                        <div>
                                            <Dropdown
                                                overlay={
                                                    <Menu
                                                        onClick={({ key }) => {
                                                            handleAssignByMenuClick(
                                                                task.taskId,
                                                                key
                                                            )
                                                        }}
                                                    >
                                                        <Menu.Item
                                                            key="todo"
                                                            onClick={() => {
                                                                void handleProgressChange(
                                                                    1,
                                                                    'To-Do'
                                                                )
                                                            }}
                                                        >
                                                            To-Do
                                                        </Menu.Item>
                                                        <Menu.Item
                                                            key="inprogress"
                                                            onClick={() => {
                                                                void handleProgressChange(
                                                                    2,
                                                                    'In-Progress'
                                                                )
                                                            }}
                                                        >
                                                            In-Progress
                                                        </Menu.Item>
                                                        <Menu.Item
                                                            key="completed"
                                                            onClick={() => {
                                                                void handleProgressChange(
                                                                    1,
                                                                    'Complete'
                                                                )
                                                            }}
                                                        >
                                                            Completed
                                                        </Menu.Item>
                                                        <Menu.Item
                                                            key="QA"
                                                            onClick={() => {
                                                                void handleProgressChange(
                                                                    1,
                                                                    'QA'
                                                                )
                                                            }}
                                                        >
                                                            QA
                                                        </Menu.Item>
                                                        {Boolean(
                                                            activeItDepartment
                                                        ) && (
                                                            <Menu.Item
                                                                key="QA"
                                                                onClick={() => {
                                                                    void handleProgressChange(
                                                                        1,
                                                                        'QA'
                                                                    )
                                                                }}
                                                            >
                                                                QA
                                                            </Menu.Item>
                                                        )}
                                                    </Menu>
                                                }
                                                open={
                                                    selectedTaskId ===
                                                    task.taskId
                                                }
                                                onVisibleChange={(visible) => {
                                                    if (!visible) {
                                                        setSelectedTaskId('')
                                                        setSelectedStatusProjectId(
                                                            ''
                                                        )
                                                    }
                                                }}
                                            >
                                                <a
                                                    className="ant-dropdown-link"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setSelectedTaskId(
                                                            task.taskId
                                                        )
                                                    }}
                                                >
                                                    Completed
                                                </a>
                                            </Dropdown>
                                        </div>
                                        <div
                                            className={TodoStyles.circle}
                                            style={{
                                                backgroundColor:
                                                    task.daysColourCode,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                                <div
                                    className={TodoStyles.todoAllIconContainer}
                                >
                                    <div className={TodoStyles.iconContainer}>
                                        <Tooltip title="Edit Task">
                                            <FormOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreate(
                                                        task.taskId
                                                    )
                                                    setProjectStatusLable(
                                                        task.projectStatusLbl
                                                    )
                                                    openEditModal(task.taskId)
                                                    setResetData('false')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Followers">
                                            <UsergroupAddOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreateFollowers(
                                                        task.taskId
                                                    )
                                                    setResetData2('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Spent Hours">
                                            <FieldTimeOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenCreateHours(
                                                        task.taskId
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add subtask">
                                            <UnorderedListOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    handleModalOpenSubTasks(
                                                        task
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Add Task Attachment">
                                            <PaperClipOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    onAttachment(task.taskId)
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Staff Communication">
                                            <WechatOutlined
                                                className={TodoStyles.todoIcons}
                                                onClick={() => {
                                                    onChat(
                                                        task.taskId,
                                                        task.referenceId,
                                                        task.businessTypeId
                                                    )
                                                    setResetData('true')
                                                }}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <Space size={'small'}>
                                            <Tooltip
                                                title={` Assigned By ${task?.assignedByName}`}
                                            >
                                                <UserOutlined />
                                            </Tooltip>
                                            <Tooltip
                                                title={` Assigned To ${task?.assignedToName}`}
                                            >
                                                <UserOutlined />
                                            </Tooltip>
                                        </Space>
                                    </div>
                                    <div
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(3, auto)',
                                            gap: '4px',
                                        }}
                                    >
                                        {task.taskFollowerViews
                                            .filter(
                                                (follower) =>
                                                    follower?.followerImageURL !==
                                                    null
                                            )
                                            .map((follower) => (
                                                <Tooltip
                                                    key={follower.followerId}
                                                    title={`${follower.followerName}`}
                                                >
                                                    <Avatar
                                                        size={20}
                                                        src={
                                                            follower.followerImageURL
                                                        }
                                                    />
                                                </Tooltip>
                                            ))}
                                    </div>
                                </div>
                            </Card>
                        ))}
                </Card>
            </Spin>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreate}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateTaskForm
                    taskId={attachmentTaskId?.toString()}
                    onSave={onSaveTask}
                    editData={editData}
                    setResetData={setResetData}
                    resetdata={restData}
                    projectStatusLable={projectStatusLable}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateAttachment}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateattachmentModal
                    taskId={attachmentTaskId}
                    setResetData={setResetData}
                    resetdata={restData}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateHours}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreateHours
                    taskid={attachmentTaskId}
                    setResetData={setResetData}
                    resetdata={restData}
                    areaId={1}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateFollowers}
                onCancel={handleModalClose}
                footer={null}
                width={'30%'}
            >
                <CreateFollowersModal
                    onSave={onSaveTask}
                    taskid={attachmentTaskId?.toString()}
                    selectedUsers={selectedUsers}
                    setSelectedUsers={setSelectedUsers}
                    resetdata={restData2}
                    setResetData={setResetData2}
                />
            </Modal>
            <Modal
                title={modalTitleCreate}
                open={modalVisibleCreateSubTask}
                onCancel={handleModalClose}
                footer={null}
                width={'50%'}
            >
                <CreatesubtaskModal
                    taskId={attachmentTaskId}
                    getTask={getTask}
                    setResetData={setResetData}
                    restData={restData}
                />
            </Modal>
            <Drawer
                title={
                    drawerDetails !== null ? (
                        <>
                            <Row>
                                <Col span={24}>
                                    <span style={{ color: 'white' }}>
                                        {drawerDetails.clientName}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    Period of{' '}
                                    {formatdate(drawerDetails.periodStartDate)}{' '}
                                    to {formatdate(drawerDetails.periodEndDate)}
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <Skeleton active />
                    )
                }
                open={modalVisibleCreateChat}
                onClose={handleModalClose}
                footer={null}
                width={550}
                styles={{
                    header: {
                        backgroundColor: '#085394',
                        padding: '20px',
                        marginBottom: '0',
                        color: 'white',
                    },
                    content: { padding: '0' },
                    body: { backgroundColor: 'yello' },
                }}
            >
                <ChatClient
                    taskId={Number(attachmentTaskId)}
                    messageTypeId={2}
                    referenceId={referenceId}
                    businessId={businessId}
                    setDrawerDetaisl={setDrawerDetaisl}
                    setResetData={setResetData}
                    resetdata={restData}
                />
            </Drawer>
        </div>
    )
}

const mapStateToProps = (state: any): todoSatteInterface => {
    return {
        userList: state.user.userList,
        projectDropDownList: state.helpdesk.projectDropDownList,
        taskDetailsListCount: state.helpdesk.taskDetailsListCount,
        userimageList: state.helpdesk.userimageList,
        ProjectManagmentStausList: state.initial.ProjectManagmentStausList,
        taskDetailsList: state.helpdesk.taskDetailsList,
    }
}

export default connect(mapStateToProps)(CompletedTask)
